import React from 'react';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import './SortHeader.scss';

export type SortDirection = 'asc' | 'desc';

interface Props {
  label: string;
  column: string;
  sortBy: string;
  sortDirection: SortDirection;
  onSort: (column: string) => void;
}

const SortHeader: React.FC<Props> = ({ label, column, sortBy, sortDirection, onSort }) => {
  const active = sortBy === column;
  return (
    <button type="button" className="sort-header" onClick={() => onSort(column)}>
      <span>{label}</span>
      {active ? (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />) : <FaSort />}
    </button>
  );
};

export default SortHeader;
